module.exports = __webpack_public_path__ + "img/bottom.0c4df7ad.png";